<template>
  <div id="home-view">
    <div style="position: relative">
      <el-carousel height="890px" :interval="5000" arrow="always">
        <el-carousel-item>
          <div>
            <div class="banner-font-container">
              <p style="font-size: 72px; font-weight: bold">礼邦物流</p>
              <p>专业的管理人员和运输队伍;</p>
              <p>严格、科学的管理手段,现代化的办公设施;</p>
              <p>通过物流配送服务,将客户的货品运达全球任何地方</p>
              <div style="display: flex">
                <el-button
                  :style="{
                    backgroundColor: 'transparent',
                    color: 'rgb(255 255 255)',
                  }"
                  @click="router.push('/about')"
                  >关于我们</el-button
                >
                <el-button
                  :style="{
                    backgroundColor: 'transparent',
                    color: 'rgb(255 255 255)',
                  }"
                  @click="router.push('/services')"
                  style="margin-left: 15px"
                  >服务简介</el-button
                >
              </div>
            </div>
            <img
              style="height: 100%"
              src="../assets/index/banner1.png"
              alt="logo"
            />
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div>
            <img
              style="height: 100%"
              src="../assets/index/banner2.png"
              alt="logo"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div style="height: 655px; padding-top: 147px; background-color: #fff">
      <font-overlay
        front-end-font="关于礼邦"
        backend-font="ABOUT&nbsp; REPPON"
        class-name="ABOUT_REPPON"
      />
      <div class="about-reppon-text wenText">
        <p>
          上海礼邦物流有限公司(REPPON LOGISTICS)成立于2002年，专业从事进出口集装箱运输、仓储、进口拆箱以及出口拼箱等多种形式的业务服务。
        </p>
        <p>&nbsp;</p>
        <p>
          公司拥有一批从事物流方面的专业人才，员工均接受过专业培训，本司坚持以市场为导向、以客户为中心、以“感动服务”为行动的经营方针;
        </p>
        <p>&nbsp;</p>
        <p>
          采用现代物流先进的管理模式，可提供全方位一体化的物流服务，公司建立了一整套完整的物流服务管理系统，从客户接待、业务洽谈、货物运输、客户意见反馈、电话回访等、都有专人负责，专人管理。
        </p>
      </div>
    </div>
    <div style="height: 700px; background-color: #f3f3f3; margin-top: 120px">
      <font-overlay
        front-end-font="服务介绍"
        backend-font="SERVICE&nbsp; INTRODUCTION"
        class-name="SERVICE_INTRODUCTION"
      />
      <div style="display: flex; margin-top: 90px; justify-content: center">
        <function-box icon="reppon-icon icon-icon_519" text="订舱" />
        <function-box icon="reppon-icon icon-shiyongwendang" text="报关" />
        <function-box icon="reppon-icon icon-huowudui" text="运输" />
        <function-box icon="reppon-icon icon-cangku" text="仓储" />
        <function-box icon="reppon-icon icon-wuliuqiache" text="堆场" />
      </div>
    </div>
    <div
      style="
        padding-top: 70px;
        padding-bottom: 200px;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      "
    >
      <font-overlay
        backend-font="OUR CUSTOMERS"
        class-name="OUR_CUSTOMERS"
        front-end-font="我们的客户"
      />
      <div
        style="
          margin-top: 50px;
          width: 1100px;
          justify-content: center;
          align-items: center;
          display: grid;
          grid-template-columns: repeat(5, 1fr); /* 每行最多显示5列 */
          gap: 80px; /* 图片之间的间距 */
        "
      >
        <div
          v-for="(image, index) in images"
          :key="index"
          class="image-container"
        >
          <img
            :src="image"
            alt=""
            style="width: 100%; height: 80px; object-fit: contain"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import FontOverlay from "@/components/FontOverlay.vue";
import FunctionBox from "@/components/FunctionBox.vue";
import { ref } from "vue";
import asusImg from "@/assets/customers/asus.png";
import dhl from "@/assets/customers/dhl.png";
import c1Img from "@/assets/customers/c1.png";
import expe from "@/assets/customers/expeditors.png";
import chro from "@/assets/customers/chrobinson.png";
import cmcl from "@/assets/customers/chinaMerchantsLogistics.png";
import ceva from "@/assets/customers/ceva.png";
import philips from "@/assets/customers/philips.png";
import cat from "@/assets/customers/cat.png";
import hisense from "@/assets/customers/hisense.png";
import ikea from "@/assets/customers/ikea.png";
import foxconn from "@/assets/customers/foxconn.png";
import walmart from "@/assets/customers/walmart.png";
import router from "@/router";

const images = ref([
  dhl,
  expe,
  chro,
  cmcl,
  ceva,
  asusImg,
  philips,
  cat,
  c1Img,
  hisense,
  ikea,
  foxconn,
  walmart,
]);
document.addEventListener("scroll", function () {
  const yunshuInDiv = document.querySelector(".wenText");
  if (yunshuInDiv) {
    const yunshu1Position = yunshuInDiv.getBoundingClientRect().top;
    const yunshu2Position = window.innerHeight;

    if (yunshu1Position < yunshu2Position) {
      yunshuInDiv.classList.add("hide");
    }
  }
});
</script>
<style scoped>
.wenText {
  transform: scale(0); /* 初始状态：缩小到 0 */
  transition: transform 1s ease-out; /* 过渡效果：0.5秒缩放 */
}
.wenText.hide {
  transform: scale(1);
}
/* For demo */
:deep(.slick-slide) {
  text-align: center;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

:deep(.slick-arrow.custom-slick-arrow) {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  transition: ease all 0.3s;
  opacity: 0.3;
  z-index: 1;
}

:deep(.slick-arrow.custom-slick-arrow:before) {
  display: none;
}

:deep(.slick-arrow.custom-slick-arrow:hover) {
  color: #fff;
  opacity: 0.5;
}

:deep(.slick-slide h3) {
  color: #fff;
}

.about-reppon-container {
}

.about-reppon-text {
  text-align: left;
  margin-left: 25%;
  margin-top: 60px;
  width: 930px;
}

.about-reppon-text p {
  font-size: 16px;
}

.image-container {
  width: 170px;
  height: 70px;
  display: grid;
}

.banner-font-container {
  position: absolute;
  top: 25%;
  left: 25%;
}

.banner-font-container p {
  color: #fff;
  line-height: 20px;
  text-align: left;
  font-size: 18px;
}
</style>
